module.exports = __webpack_public_path__ + "img/gourmet-babies.aae48f17.jpg";